import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MatomoTracker } from 'ngx-matomo-client';
import { Subscription } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    standalone: false
})
export class LoginComponent implements OnDestroy {
  errorText: string = "";
  errorStatusCode: number = 0;
  navigateAfterLogin: string = '/home';
  loginForm : FormGroup;
  userCheckSub: Subscription;
  showPassword: boolean = false;

  constructor(private authService: AuthService,
              private router : Router,
              private fb: FormBuilder,
              private matomoTracker: MatomoTracker,
              private activatedRoute: ActivatedRoute) {

    let returnUrl = this.activatedRoute.snapshot.queryParamMap.get('returnUrl')
    if (returnUrl?.length) {
      this.navigateAfterLogin = returnUrl;
    }

    this.userCheckSub = this.authService.user$.subscribe(user => {
      if(user.loggedIn) {
        this.router.navigateByUrl(this.navigateAfterLogin);
      }
    });

    this.loginForm = this.fb.group({
      username: ['', Validators.required],
      password: ['', Validators.required]
    });
  }

  ngOnDestroy() {
    this.userCheckSub.unsubscribe();
  }

  login() {
    this.authService.login({username: this.loginForm.controls['username'].value, password: this.loginForm.controls['password'].value})
        .subscribe({
          next: (user) =>  {
            let newrelic = (window as any).newrelic;
            if (newrelic && newrelic.setUserId)  {
              newrelic.setUserId(user.id);
              newrelic.recordReplay();
            }
            this.matomoTracker.setUserId(user.id);
            this.router.navigateByUrl(this.navigateAfterLogin)
          },
          error: (err : HttpErrorResponse) => {
            this.errorStatusCode = err.status;
          }
        });
  }

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }

  signInWithGoogle() {
    let newrelic = (window as any).newrelic;
    if (newrelic && newrelic.pauseReplay) {
      newrelic.pauseReplay();
    }
    window.location.href = `${location.protocol}//${location.host}/api/v1/identity/external/Google?returnUrl=${encodeURIComponent(this.navigateAfterLogin)}`;
  }
}
